import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { enableBorderConnectFormSchema } from './enable-borderconnect-form.schema'

export const useEnableBorderConnectForm = () => {
  return useForm({
    resolver: yupResolver(enableBorderConnectFormSchema),
    defaultValues: enableBorderConnectFormSchema.cast({}),
  })
}
